// Question media (images) are stored as relative paths like
// "/uploads/images/x.png". Prefix them with the API origin so they load
// in the app; leave absolute URLs (S3/CDN/data) untouched.
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

export function resolveMediaUrl(u?: string | null): string | null {
  if (!u) return null;
  if (/^https?:\/\//.test(u) || u.startsWith("data:")) return u;
  return `${API_BASE}${u.startsWith("/") ? "" : "/"}${u}`;
}
